export const PROJECT_NAME = 'Kamilstore';

// On localhost, use direct production API by default (proxy optional via env).
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const PRODUCTION_API_BASE = 'https://api-secure.kamilstore.it';
// Default to direct API even on localhost to avoid proxy upstream resets.
// Set REACT_APP_USE_DEV_PROXY=true only if you explicitly want CRA proxy routing.
// Read straight off process.env.
//
// Webpack substitutes each REACT_APP_* lookup at build time but leaves a bare
// `process` alone, and the browser has no `process` object — so guarding with
// `typeof process !== 'undefined'` throws the substituted value away and falls
// through to production no matter what the .env file says.
const useDevProxy =
  String(process.env.REACT_APP_USE_DEV_PROXY || '').toLowerCase() === 'true';
// Point the dashboard at a backend running on this machine.
//
// Needed for anything that only exists locally — a route added here but not
// yet deployed answers "Route not found" against production, which is not a
// bug in the page asking for it. Unset by default, so nothing changes for
// anyone who does not opt in.
//
//   REACT_APP_API_BASE=http://localhost:3000
const explicitBase = String(process.env.REACT_APP_API_BASE || '').trim();

const base = explicitBase
  ? explicitBase.replace(/\/+$/, '')
  : isLocalhost && useDevProxy
    ? ''
    : PRODUCTION_API_BASE.replace(/\/+$/, '');
export const BASE_URL = base ? base + '/' : '';
// www, not the apex: the apex answers with a 301 to www, so a frame or link
// opened on the apex lands on www — and the banner live preview posts to and
// listens for this exact origin, which then never matched.
export const WEBSITE_URL = 'https://www.kamilstore.it';

/**
 * Where the storefront lives, for the banner preview frame.
 *
 * The dashboard cannot render a storefront component, so the coded-banner
 * preview frames the storefront's own /banner-preview route and posts the draft
 * into it. That means the dashboard needs to know the site's origin, which is
 * `WEBSITE_URL` in production and a local dev server while working on it.
 *
 * Set REACT_APP_STOREFRONT_ORIGIN to point somewhere else (a staging site, or a
 * dev server on a different port).
 */
export const STOREFRONT_ORIGIN = (
  String(process.env.REACT_APP_STOREFRONT_ORIGIN || '').trim() ||
  (isLocalhost ? 'http://localhost:3001' : WEBSITE_URL)
).replace(/[/]+$/, '');
export const PRODUCTION_ADMIN_ORIGIN = 'https://admin.kamilstore.it';

function joinPath(base, path) {
  const b = (base || '').replace(/\/+$/, '');
  const p = (path || '').replace(/^\/+/, '');
  return b ? `${b}/${p}` : `/${p}`;
}
export const api_url = joinPath(base, 'api/v1/');
export const api_url_admin = joinPath(base, 'api/v1/dashboard/admin/');
export const api_url_admin_dashboard = joinPath(base, 'api/v1/dashboard/');
export const IMG_URL = '';
export const MAP_API_KEY = '';
export const export_url = joinPath(base, 'storage/');
export const example = BASE_URL;
export const defaultCenter = { lat: 40.7127281, lng: -74.0060152 };

// Single-shop: default currency for display (no admin CRUD).
export const DEFAULT_CURRENCY = { symbol: '€', title: 'EUR' };

/** Matches backend GLOBAL_ADMIN_ID (.env). When empty, coupon/special-offer mutation controls stay visible; API still enforces permissions. */
export const GLOBAL_ADMIN_ID = (
  typeof process !== 'undefined' && process.env?.REACT_APP_GLOBAL_ADMIN_ID
    ? String(process.env.REACT_APP_GLOBAL_ADMIN_ID).trim()
    : ''
);

export function isGlobalAdmin(user) {
  if (!user) return false;
  if (!GLOBAL_ADMIN_ID) return true;
  const uid = user.id ?? user._id;
  return uid != null && String(uid) === GLOBAL_ADMIN_ID;
}

// Firebase (Kamil Store – Firestore chat collection)
export const VAPID_KEY = '';
export const API_KEY = 'AIzaSyDHNwGNpe-yjFGJdmiNTrmzJiBuXSvzA-M';
export const AUTH_DOMAIN = 'kamilstore-38b02.firebaseapp.com';
export const PROJECT_ID = 'kamilstore-38b02';
export const STORAGE_BUCKET = 'kamilstore-38b02.firebasestorage.app';
export const MESSAGING_SENDER_ID = '964716059720';
export const APP_ID = '1:964716059720:web:5886234379f9931ac78c7d';
export const MEASUREMENT_ID = 'G-5SE7739QV3';
export const DYNAMIC_LINK_DOMAIN = '';
export const ANDROID_PACKAGE_NAME = '';
export const IOS_BUNDLE_ID = '';

// reCAPTCHA v2 site key for login. Leave empty to skip reCAPTCHA (e.g. local dev).
export const RECAPTCHASITEKEY = '';


export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];

